
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M787.9 705.3H926L817.8 470.7h53L760.4 249.8 650 470.7h53.1L594.8 705.3h151.7v179.3H360.2V732.9h220.9L422.4 415.5h75.8L339.5 98 180.8 415.5h75.9L98.1 732.9h220.7v151.7H98V926h827.9v-41.4h-138V705.3zm-621-14.1l158.9-317.3h-76.1l89.8-179.3 89.8 179.3h-76l158.9 317.3H166.9zm593.5-344.8l41.4 82.7h-82.9l41.5-82.7zm-96.7 317.3l96.7-193.1 96.7 193.1H663.7z","fill":"#fff"}})])
          )
        }
      }
    